import { CREATE_BELEGUNGEN } from '@/domain/dienstplan/features/VisualEditor/hooks/useBelegungen/graphql/mutations';
import {
  Dienstplan_CreateBelegungMutation,
  Dienstplan_CreateBelegungMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

export function useCreateBelegungen() {
  const [execute, result] = useMutation<
    Dienstplan_CreateBelegungMutation,
    Dienstplan_CreateBelegungMutationVariables
  >(CREATE_BELEGUNGEN, {
    refetchQueries: [
      'dienstplan_arbeitsbereichByStandortId',
      'dienstplan_getBelegungen',
    ],
    awaitRefetchQueries: true,
  });

  const createBelegung = useCallback(
    (variables: Dienstplan_CreateBelegungMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createBelegung, result] as const;
}
